export const SITE_STATUS_LOADING = Symbol("SITE_STATUS_LOADING");
// export const TX_STATUS_ERROR = Symbol("TX_STATUS_ERROR");
// export const TX_STATUS_PENDING = Symbol("TX_STATUS_PENDING");
// export const TX_STATUS_SUCCESS = Symbol("TX_STATUS_SUCCESS");
